<template>
  <div>
    <div
      style="text-algin:left"
      @click="getDetail"
      class="accent_color pointer text-dense"
    >{{params.data.invoiceNumber||params.data.invoiceDocumentFilename}}</div>
  </div>
</template>
<script>
export default {
  mounted() {
    // colDef
  },
  methods: {
    getDetail() {
      let { data, colDef } = this.params;
      this.$store.dispatch("setActionNoticModal", {
        show: true,
        data: {
          title: this.$t("ReceDetail.Receivable.Details"),
          type: "ReceivableDetailsModal",
          width: 800,
          data: data
        }
      });
    }
  }
};
</script>
